import { render, staticRenderFns } from "./PapermanSubjectPicker.vue?vue&type=template&id=73c23a37&"
import script from "./PapermanSubjectPicker.vue?vue&type=script&lang=js&"
export * from "./PapermanSubjectPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports